import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCMS } from "../context/CMSContext";
import NotificationBell from "./NotificationBell";
import { NavLink } from "react-router-dom";
import { MapPinned } from "lucide-react";
import {
  LayoutDashboard,
  Server,
  Users,
  CreditCard,
  Ticket,
  Bell,
  FileText,
  LogOut,
  Wifi,
  Router,
  Menu,
  X,
  ChevronLeft,
  Activity,
  DollarSign,
  Wallet,
} from "lucide-react";

export default function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { settings } = useCMS();
  const companyName = settings?.company_name || "ISP Manager";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    {
      path: "/admin/dashboard",
      icon: LayoutDashboard,
      label: "Dashboard",
      testId: "admin-nav-dashboard",
    },
    {
      path: "/admin/activity-logs",
      icon: Activity,
      label: "Activity Logs",
      testId: "admin-nav-activity-logs",
    },
    {
      path: "/admin/servers",
      icon: Server,
      label: "Servers",
      testId: "admin-nav-servers",
    },
    // {
    //   path: "/admin/areas",
    //   icon: Server,
    //   label: "Areas",
    //   testId: "admin-nav-areas",
    // },
    {
      path: "/admin/nap-boxes",
      icon: Server,
      label: "NAP Boxes",
      testId: "admin-nav-napboxes",
    },
    {
      path: "/admin/nap-box-network-map",
      icon: Server,
      label: "NAP Box Network Map",
      testId: "admin-nav-napboxnetworkmap",
    },
    {
      path: "/admin/plans",
      icon: CreditCard,
      label: "Plans",
      testId: "admin-nav-plans",
    },
    {
      path: "/admin/new-applications",
      icon: Users,
      label: "New Applications",
      testId: "admin-nav-new-applications",
    },
    {
      path: "/admin/clients",
      icon: Users,
      label: "Subscribers",
      testId: "admin-nav-clients",
    },
    {
      path: "/admin/payments",
      icon: CreditCard,
      label: "Payments",
      testId: "admin-nav-payments",
    },
    {
      path: "/admin/sales-reports",
      icon: DollarSign,
      label: "Sales Reports",
      testId: "admin-nav-sales-reports",
    },
    {
      path: "/admin/generated-soa",
      icon: Users,
      label: "Generated SOA",
      testId: "admin-nav-generated-soa",
    },
    {
      path: "/admin/cashflow",
      icon: Wallet,
      label: "Cash Flow",
      testId: "admin-nav-cashflow",
    },
    {
      path: "/admin/tickets",
      icon: Ticket,
      label: "Tickets",
      testId: "admin-nav-tickets",
    },
    {
      path: "/admin/announcements",
      icon: Bell,
      label: "Announcements",
      testId: "admin-nav-announcements",
    },
    {
      path: "/admin/users",
      icon: Users,
      label: "Users",
      testId: "admin-nav-users",
    },
    {
      path: "/admin/mikrotik",
      icon: Router,
      label: "MikroTik",
      testId: "admin-nav-mikrotik",
    },
    {
      path: "/admin/cms",
      icon: FileText,
      label: "CMS",
      testId: "admin-nav-cms",
    },
  ];

  return (
    <div className="flex h-dvh bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
            <Wifi className="w-4 h-4 text-white" />
          </div>
          <span className="font-bold text-slate-900">{companyName}</span>
        </div>
        <div className="flex items-center gap-2">
          <NotificationBell />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            data-testid="mobile-menu-toggle"
          >
            {sidebarOpen ? (
              <X className="w-5 h-5" />
            ) : (
              <Menu className="w-5 h-5" />
            )}
          </Button>
        </div>
      </div>

      {/* Mobile Backdrop */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/30 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      {/* <aside
        className={`
        fixed lg:sticky top-0 left-0 z-50 h-screen bg-white border-r border-slate-200 flex flex-col shadow-sm
        transition-all duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        ${sidebarCollapsed ? "lg:w-20" : "lg:w-64"}
        w-64
      `}
      > */}
      <aside
        className={`
          fixed lg:sticky top-0 left-0 z-50
          h-dvh overflow-y-auto
          bg-white border-r border-slate-200 flex flex-col shadow-sm
          transition-all duration-300 ease-in-out
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
          ${sidebarCollapsed ? "lg:w-20" : "lg:w-64"}
          w-64
        `}
      >
        <div
          className={`p-4 lg:p-6 border-b border-slate-100 ${sidebarCollapsed ? "lg:px-3" : ""}`}
        >
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-500/30 flex-shrink-0">
              <Wifi className="w-5 h-5 text-white" />
            </div>
            <div className={`${sidebarCollapsed ? "lg:hidden" : ""}`}>
              <h1 className="text-lg font-bold text-slate-900">
                {companyName}
              </h1>
              <p className="text-xs text-slate-500">Admin Portal</p>
            </div>
          </div>
        </div>

        {/* Collapse Toggle (Desktop only) */}
        <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className="hidden lg:flex absolute -right-3 top-20 w-6 h-6 bg-white border border-slate-200 rounded-full items-center justify-center shadow-sm hover:bg-slate-50 transition-colors z-50"
          data-testid="sidebar-collapse-toggle"
        >
          <ChevronLeft
            className={`w-4 h-4 text-slate-500 transition-transform ${sidebarCollapsed ? "rotate-180" : ""}`}
          />
        </button>

        {/* <nav
          className={`flex-1 p-4 space-y-1 overflow-y-auto ${sidebarCollapsed ? "lg:p-2" : ""}`}
        > */}
        <nav
          className={`flex-1 min-h-0 p-4 space-y-1 overflow-y-auto ${
            sidebarCollapsed ? "lg:p-2" : ""
          }`}
        >
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={item.testId}
              onClick={() => setSidebarOpen(false)}
              title={sidebarCollapsed ? item.label : undefined}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 group ${
                sidebarCollapsed ? "lg:px-3 lg:justify-center" : ""
              } ${
                isActive(item.path)
                  ? "bg-blue-50 text-blue-600 shadow-sm"
                  : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
              }`}
            >
              <item.icon
                className={`w-5 h-5 transition-transform group-hover:scale-110 flex-shrink-0 ${
                  isActive(item.path) ? "text-blue-600" : "text-slate-400"
                }`}
              />
              <span
                className={`font-medium text-sm ${sidebarCollapsed ? "lg:hidden" : ""}`}
              >
                {item.label}
              </span>
            </Link>
          ))}
        </nav>

        <div
          className={`p-4 border-t border-slate-100 bg-slate-50 ${sidebarCollapsed ? "lg:p-2" : ""}`}
        >
          <div className={`mb-3 px-2 ${sidebarCollapsed ? "lg:hidden" : ""}`}>
            <p className="text-sm font-semibold text-slate-900 truncate">
              {user.full_name}
            </p>
            <p className="text-xs text-slate-500 truncate">{user.email}</p>
          </div>
          <div
            className={`hidden lg:flex mb-3 justify-center ${sidebarCollapsed ? "" : "lg:hidden"}`}
          >
            <NotificationBell />
          </div>
          <Button
            onClick={handleLogout}
            data-testid="admin-logout-btn"
            variant="outline"
            title={sidebarCollapsed ? "Logout" : undefined}
            className={`w-full gap-2 text-slate-600 border-slate-200 hover:bg-white hover:text-slate-900 rounded-lg ${
              sidebarCollapsed ? "lg:justify-center lg:px-2" : "justify-start"
            }`}
          >
            <LogOut className="w-4 h-4 flex-shrink-0" />
            <span className={sidebarCollapsed ? "lg:hidden" : ""}>Logout</span>
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto pt-14 lg:pt-0">
        {/* Desktop Notification Bell - Top Right */}
        <div className="hidden lg:flex justify-end px-6 py-3 border-b border-slate-100 bg-white/50">
          <NotificationBell />
        </div>
        {children}
      </main>
    </div>
  );
}
